export default __webpack_public_path__ + "static/Respurce-73309581ff7d30d0a2f547b580740944.png";